module.exports = __webpack_public_path__ + "img/5.1.ba80f462.jpg";